/* eslint-disable */
import { Reducer } from "redux";
import { initialValues } from "src/helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle";
import * as types from "../../Types/common";
import { MedicalDetailsInterface } from "./interface";
import { bindMedicalLifestyleAPIData } from "src/helpers/FormDetails";
import {
  SAVE_MEDICAL_AND_LIFESTYLE_V2,
  SET_MEDICAL_AND_LIFESTYLE_V2
} from "src/redux/Types/medical&LifestyleV2";

const initialState: MedicalDetailsInterface = {
  ...initialValues,
  applicationId: "",
  medicalDetailsV2: {}
};

// eslint-disable-next-line default-param-last
const medicalAndLifeStyleReducer: Reducer<MedicalDetailsInterface> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case types.SAVE_MEDICAL_AND_LIFESTYLE: {
      const data = bindMedicalLifestyleAPIData(state, action.payload.apiData);
      return {
        ...state,
        medicalDetails: data.medicalDetails,
        applicationId: action.payload.leadId
      };
    }
    case types.SET_MEDICAL_AND_LIFESTYLE: {
      return { ...state, ...action.payload };
    }
    case SET_MEDICAL_AND_LIFESTYLE_V2: {
      return { ...state, medicalDetailsV2: action?.payload };
    }
    case SAVE_MEDICAL_AND_LIFESTYLE_V2: {
      const data = action?.payload?.apiData?.Members?.filter((m: any) => !m?.isJointMember)[0];
      return {
        ...state,
        medicalDetailsV2: data?.medicalAndLifeStyle,
        applicationId: action.payload.leadId
      };
    }
    default:
      return state;
  }
};

export { medicalAndLifeStyleReducer };
